(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TradingCycleFull", [], factory);
	else if(typeof exports === 'object')
		exports["TradingCycleFull"] = factory();
	else
		root["TradingCycleFull"] = factory();
})(self, () => {
return 